import ipRegex from "ip-regex";
const defaultOpts = {
  exact: false
};
const v4str = "".concat(ipRegex.v4().source, "\\/(3[0-2]|[12]?[0-9])");
const v6str = "".concat(ipRegex.v6().source, "\\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])");

// pre-compile only the exact regexes as global flag makes regex objects stateful
const v4exact = new RegExp("^".concat(v4str, "$"));
const v6exact = new RegExp("^".concat(v6str, "$"));
const v46exact = new RegExp("(?:^".concat(v4str, "$)|(?:^").concat(v6str, "$)"));
const cidrRegex = function () {
  let {
    exact
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOpts;
  return exact ? v46exact : new RegExp("(?:".concat(v4str, ")|(?:").concat(v6str, ")"), "g");
};
export const v4 = cidrRegex.v4 = function () {
  let {
    exact
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOpts;
  return exact ? v4exact : new RegExp(v4str, "g");
};
export const v6 = cidrRegex.v6 = function () {
  let {
    exact
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOpts;
  return exact ? v6exact : new RegExp(v6str, "g");
};
export default cidrRegex;